module.exports = __webpack_public_path__ + "img/7435784.svg";